import { ReactElement } from 'react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@sandtech-hub-monorepo/ui-kit';

interface Props {
  reason?: string | null;
  children: ReactElement;
}

/** Wraps a revoked badge card: hovering anywhere on it shows why. */
export const RevocationTooltip = ({ reason, children }: Props) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent className="max-w-xs">
        <p className="font-medium">Revoked</p>
        <p className="text-xs">{reason || 'No reason was given.'}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
